import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToDomesticQuote,
    navigateToPersonalDetails,
    navigateToBuildingDetails,
    navigateToDocuments,
    navigateToPayment
} from '../../../actions/domesticInsurance/routing';
import { getActivePageIndex } from '../../../selectors/domesticInsurance/routing';
import { PAGE_INDICES } from '../../../actions/domesticInsurance/types';
import { apiTransitionDocumentsForm } from '../../../actions/domesticInsurance/Documents';
import { apiTransitionPersonalDetailsForm } from '../../../actions/domesticInsurance/personalDetails';
import { apiTransitioncarDetailsForm } from '../../../actions/domesticInsurance/buildingDetails';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS)
        return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToBuildingDetails());
            break;
        case PAGE_INDICES.BUILDING_DETAILS:
            store.dispatch(navigateToDocuments());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToDomesticQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToDomesticQuote());
            break;

        case PAGE_INDICES.BUILDING_DETAILS:
            store.dispatch(apiTransitionPersonalDetailsForm.initial());
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(apiTransitioncarDetailsForm.initial());
            store.dispatch(navigateToBuildingDetails());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionDocumentsForm.initial());
            store.dispatch(navigateToDocuments());
            break;
        default:
            store.dispatch(navigateToDomesticQuote());
            break;
    }
};
